import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { ThemeStoreEffects } from './theme.effects';
import { EffectsModule } from '@ngrx/effects';
import { themeReducer } from './theme.reducer';
import { THEME_FEATURE } from './theme.selectors';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(THEME_FEATURE, themeReducer),
    EffectsModule.forFeature([ThemeStoreEffects]),
  ],
})
export class ThemeStoreModule {}
